<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="800" height="600" :show-footer="false" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" title="任务配置" :loading="loading">
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="configList"></vxe-grid>
				<collection-config ref="collection_configIndex" :data="currentrow" @success="configSuccess" />
				<compensationnotice-config ref="compensationnotice_configIndex" :data="currentrow"  @success="configSuccess" />
				<offer-config ref="offer_configIndex" :data="currentrow"  @success="configSuccess" />
				<stockwarning-config ref="stockwarning_configIndex" :data="currentrow"  @success="configSuccess" />
				<restock-config ref="restock_configIndex" :data="currentrow"  @success="configSuccess" />
			</template>
			
			
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import collectionConfig from './collection/config/index.vue'
	import compensationnoticeConfig from './compensationnotice/config/index.vue'
	import offerConfig from './offer/config/index.vue'
	import stockwarningConfig from './stockwarning/config/index.vue'
	import restockConfig from './restock/config/index.vue'
	
	export default {
		mixins: [listMixins],
		props: {
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			action: {
				default: () => {
					return ''
				}
			}
		},
		data() {
			return {
				currentrow: {},
				loading: false,
				model: true,
				tableList: [],
				orderinfo: [],
				gridOptions: null,
				tabledata: [],
				exportRef: 'export_' + Math.random(),
				primarykey: '业务订单号',
				buff: true,
				isfinish: true,
				totalNum: 0,
				progress: 0
			}
		},
		created() {

		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 450
				gridOptions.columns = [{
						field: 'module',
						title: '模块',
					}, {
						field: 'mark',
						title: '备注',
						showOverflow: false,
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						cellRender: {
							bind: this,
							name: '$operateButton',
							buttons: [{
								code: 'edit',
								content: '编辑',
								status: 'primary',
								inrow: true
							}]
						}
					}
				]
				gridOptions.toolbarConfig.buttons = []
				gridOptions.formConfig = false
			},
			operateButtonClickEvent(e) {
				if (this[e.code]) {
					this[e.code](e.data)
				}
			},
			edit(e) {
				this.currentrow = e
				this.$nextTick(()=>{
					if(this.currentrow.module == 'compensationnotice'){
						this.$refs.compensationnotice_configIndex.modal_show()
					}	
					if(this.currentrow.module == 'offer'){
						this.$refs.offer_configIndex.modal_show()
					}
					if(this.currentrow.module == 'collection'){
						this.$refs.collection_configIndex.modal_show()
					}
					if(this.currentrow.module == 'stockwarning'){
						this.$refs.stockwarning_configIndex.modal_show()
					}
					if(this.currentrow.module == 'restock'){
						this.$refs.restock_configIndex.modal_show()
					}
				})

			},
			configSuccess(){
				this.$refs.configList.commitProxy('query')
			},
			list() {
				return new Promise((resolve) => {
					this.$api.config.list().then((res)=>{
						resolve({
							list: res
						})
					},()=>{
						resolve({
							list: []
						})
					})
				})
			},
			show() {
				this.progress = 0
				this.buff = true
			},
			hide() {
				this.progress = 0
				this.buff = false
				this.$emit('hide')
			},
		},
		components: {
			collectionConfig,
			compensationnoticeConfig,
			offerConfig,
			stockwarningConfig,
			restockConfig
		}
	}
</script>